import { route, tag, type PageTour } from '../pageTour';

export const discoveryTour: PageTour = {
  id: 'page-discovery',
  version: 1,
  title: 'Camera Discovery',
  summary: 'Find cameras on the site network and add them.',
  match: route('/discovery'),
  steps: [
    {
      target: tag('discovery-subnets'),
      title: 'Choose a network',
      description: 'Pick the address range the cameras are on, or enter your own.',
      side: 'right',
    },
    {
      target: tag('discovery-scan'),
      title: 'Scan the network',
      description: 'Search the chosen range for ONVIF cameras. Results appear as they are found.',
      side: 'right',
      permission: 'discovery.view',
    },
    {
      target: tag('discovery-results'),
      title: 'Discovered cameras',
      description: 'Cameras found by the scan are listed here. Add one at a time, or tick several and add them together.',
      side: 'top',
    },
  ],
};
